var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcWarningFill = function SvgIcWarningFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.995 8.204a1 1 0 1 0-2 0v4.42a1 1 0 0 0 2 0zm-1 6.342a1.25 1.25 0 1 0 0 2.5h.01a1.25 1.25 0 0 0 0-2.5zM12 1.75c5.66 0 10.25 4.589 10.25 10.25S17.66 22.25 12 22.25 1.75 17.66 1.75 12 6.339 1.75 12 1.75",
    clipRule: "evenodd"
  })));
};
export default SvgIcWarningFill;